import { render, staticRenderFns } from "./PanelSelect.vue?vue&type=template&id=3689b332&scoped=true&"
import script from "./PanelSelect.vue?vue&type=script&lang=js&"
export * from "./PanelSelect.vue?vue&type=script&lang=js&"
import style0 from "./PanelSelect.vue?vue&type=style&index=0&id=3689b332&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3689b332",
  null
  
)

export default component.exports